<script lang="ts" setup>
import logoForLightTheme from '@/assets/images/header/logo-for-light-theme.svg'
import logoForDarkTheme from '@/assets/images/header/logo-for-dark-theme.svg'
import { useAuth, useProfile } from 'auth-package'
import { useRoute, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useLayoutPreferencesStore } from '@/stores/layout/layoutPreferences'

const layoutPreferences = useLayoutPreferencesStore()
const { isDarkMode } = storeToRefs(layoutPreferences)
const profile = useProfile()

defineOptions({
    name: 'ElHeader'
})

const route: any = useRoute()
const router: any = useRouter()

function handleCommand(command: string) {
    if (command == 'toggleTheme') {
        layoutPreferences.darkModeToggle()
        // router.push({
        //     name: 'accountSettings'
        // })
    } else if (command == 'logout') {
        useAuth().logout()
    }
}
</script>

<template>
    <header>
        <el-row class="content" justify="space-between">
            <el-col :span="8">
                <!--<el-breadcrumb separator="/" class="hidden-xs-only">
                    <el-breadcrumb-item
                        v-for="(breadcrumb, index) in route.meta.breadcrumbs"
                        :to="{ name: breadcrumb.routeName, params: breadcrumb.routeParams ?? {} }"
                        v-bind:key="'header-breadcrumbs-' + index"
                    >
                        {{ breadcrumb.name }}
                    </el-breadcrumb-item>
                </el-breadcrumb>-->
            </el-col>
            <el-col :span="8">
                <div class="logo-wrapper">
                    <RouterLink to="/">
                        <img
                            :src="isDarkMode ? logoForDarkTheme : logoForLightTheme"
                            class="hidden-xs-only"
                        />
                    </RouterLink>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="account-wrapper">
                    <el-dropdown v-if="profile" @command="handleCommand" trigger="click">
                        <span class="el-dropdown-link avatar-wrapper">
                            <el-avatar
                                :size="32"
                                class="mr-3"
                                src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                            />
                        </span>
                        <template #dropdown>
                            <div class="dropdown-user-info">
                                <el-avatar
                                    :size="32"
                                    class="mr-2"
                                    src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                                />
                                <div class="d-flex flex-column">
                                    <div class="user-name me-auto">
                                        {{ profile.firstName }} {{ profile.lastName }}
                                    </div>
                                    <div class="user-email me-auto">
                                        {{ profile.email }}
                                    </div>
                                </div>
                            </div>
                            <el-dropdown-menu>
                                <!-- <el-dropdown-item command="toggleTheme">
                                    {{ $t('adminSubMenu.toggleTheme') }}
                                </el-dropdown-item> -->
                                <el-dropdown-item command="logout">
                                    {{ $t('settings.logout') }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </el-col>
        </el-row>
    </header>
</template>

<style lang="scss" scoped>
.el-affix {
    border-bottom: 1px solid var(--border-color);
    height: var(--header-height);
    padding: 0 12px 0 24px;
    background-image: radial-gradient(transparent 1px, var(--bg-color) 1px);
    background-size: 4px 4px;
    backdrop-filter: saturate(50%) blur(4px);
    -webkit-backdrop-filter: saturate(50%) blur(4px);
}

header {
    padding: 12px;
    // position: sticky;
    // top: 0;
    // z-index: 99;
    // background-color: var(--el-bg-color-overlay);

    .content {
        align-items: center;

        .el-breadcrumb {
            margin-right: auto;
        }

        .logo-wrapper {
            display: flex;
            justify-content: center;

            img {
                width: 124px;
            }
        }

        .account-wrapper {
            display: flex;
            justify-content: flex-end;

            .avatar-wrapper {
                display: flex;
                text-align: right;
                justify-content: right;
                align-items: center;
                cursor: pointer;
            }
        }
    }
}

.dropdown-user-info {
    display: flex;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    align-items: center;
    min-width: 240px;
    border-bottom: 1px solid var(--el-border-color-lighter);

    .user-name {
        display: block ruby;
        font-size: 16px;
        font-weight: 600;
    }

    .user-email {
        font-size: 13px;
        color: var(--el-text-color-regular);
    }
}
</style>
